function pluralize(unit, value) {
  return `${value} ${unit}${value === 1 ? "" : "S"}`;
}

const COUNTDOWN_PHASE_CLASSES = ["cd--p1", "cd--p2", "cd--p3", "cd--p4", "cd--expired"];

function getCountdownPhaseClass(startTime, endTime, now, bottlesLeftNum, isOOS, isExpired) {
  if (isNaN(startTime) || isNaN(endTime) || endTime <= startTime) return null;

  const timeExpired = now >= endTime || isExpired;
  const soldOut = bottlesLeftNum < 3 || isOOS;
  if (timeExpired || soldOut) return "cd--expired";

  const lowStock = bottlesLeftNum >= 3 && bottlesLeftNum < 50;
  if (lowStock) return "cd--p4";

  const total = endTime - startTime;
  const SEVEN_DAYS = 7 * 86400;
  const JUST_RELEASED_CAP = 2 * 86400;
  const LIMITED_TIME_CAP = 5 * 86400;
  const FINAL_HOURS_THRESHOLD = 86400;

  let phaseBounds = [total * 0.25, total * 0.5, Math.max(total - FINAL_HOURS_THRESHOLD, total * 0.5)];
  if (total > SEVEN_DAYS) {
    phaseBounds = [
      Math.min(total * 0.25, JUST_RELEASED_CAP),
      Math.min(total * 0.5, LIMITED_TIME_CAP),
      Math.max(total - FINAL_HOURS_THRESHOLD, Math.min(total * 0.5, LIMITED_TIME_CAP)),
    ];
  }

  const elapsed = Math.min(Math.max(now - startTime, 0), total);
  if (elapsed < phaseBounds[0]) return "cd--p1";
  if (elapsed < phaseBounds[1]) return "cd--p2";
  if (elapsed < phaseBounds[2]) return "cd--p3";
  return "cd--p4";
}

function initializeCountdownTimer(productId) {
  if (!document) {
    console.log("document not ready.");
    return;
  }

  const elementId = `countdown-timer-${productId}`;
  const element = document.getElementById(elementId);

  if (element) {
    const countdownDisplay = document.getElementById(
      `countdown-display-${productId}`
    );
    const bottlesLeft = element.getAttribute("data-bottles-left");
    const parsedEndTime = element.getAttribute("data-end-time");
    const parsedStartTime = element.getAttribute("data-start-time");
    const isOOS = element.getAttribute("data-offer-oos");
    const isExpired = element.getAttribute("data-offer-expired");
    let endTime;
    let startTime;

    if (/^\d+$/.test(parsedEndTime)) {
      endTime = parseInt(parsedEndTime, 10);
    } else {
      endTime = new Date(parsedEndTime).getTime() / 1000;
    }

    if (/^\d+$/.test(parsedStartTime)) {
      startTime = parseInt(parsedStartTime, 10);
    } else {
      startTime = new Date(parsedStartTime).getTime() / 1000;
    }

    if (isNaN(endTime)) {
      console.error(
        `Invalid end time for product ID: ${productId}:`,
        parsedEndTime
      );
      countdownDisplay.innerHTML = "TBD";
      return;
    }

    const updateCountdown = () => {
      const currentTime = Math.floor(Date.now() / 1000);

      let countdownText;
      let expiringText = '';
      let secondsLeft = endTime - currentTime;

      const notStarted = !isNaN(startTime) && currentTime < startTime;

      if (notStarted) {
        const remaining = startTime - currentTime;
        const daysUntil = Math.ceil(remaining / 86400);
        const hoursUntil = Math.ceil((remaining % 86400) / 3600);
        const minutesUntil = Math.ceil((remaining % 3600) / 60);

        if (daysUntil > 1) {
          countdownText = `<div>BEGINS IN <span class="bold">${pluralize("DAY", daysUntil)}</span></div>`;
        } else if (remaining >= 3600) {
          countdownText = `<div>BEGINS IN <span class="bold">${pluralize("HOUR", hoursUntil)}</span></div>`;
        } else if (remaining >= 60) {
          countdownText = `<div>BEGINS IN <span class="bold">${pluralize("MINUTE", minutesUntil)}</span></div>`;
        } else {
          countdownText = `<div>BEGINS IN <span class="bold">&lt;1 MINUTE</span></div>`;
        }
      } else {
        const days = Math.floor(secondsLeft / 86400);
        const hours = Math.floor((secondsLeft % 86400) / 3600);
        const minutes = Math.floor((secondsLeft % 3600) / 60);
        const seconds = secondsLeft % 60;

        if (days > 0) {
          countdownText = `<div><span class="bold">${pluralize("DAY", days)}</span> TO GO</div>`;
        } else if (hours > 0) {
          countdownText = `<div><span class="bold">${pluralize("HOUR", hours)}</span> TO GO</div>`;
        } else if (minutes > 0) {
          countdownText = `<div><span class="bold">${pluralize("MINUTE", minutes)}</span> TO GO</div>`;
        } else if (seconds > 0) {
          countdownText = `<div><span class="bold">&lt;1 MINUTE</span> TO GO</div>`;
        } else {
          countdownText = `<div><span class="bold">0 MINUTES</span> TO GO</div>`;
        }

        if (currentTime >= endTime) {
          expiringText = `<div class="status-badge">OFFER ENDED</div>`;
        } else if (days < 1) {
          expiringText = `<div class="status-badge">ENDS SOON</div>`;
        }
      }

      if (bottlesLeft == "0" || isExpired == 'true' || isOOS == 'true') {
        countdownText = `<div><span class="bold">0 MINUTES</span> TO GO</div>`;
        expiringText = `<div class="status-badge">OFFER ENDED</div>`;
      }

      countdownDisplay.innerHTML =
        "<div class='countdown-container'>" + countdownText + expiringText + "</div>";

      const phaseClass = notStarted
        ? null
        : getCountdownPhaseClass(
            startTime,
            endTime,
            currentTime,
            parseInt(bottlesLeft, 10),
            isOOS === 'true',
            isExpired === 'true'
          );
      countdownDisplay.classList.remove(...COUNTDOWN_PHASE_CLASSES);
      if (phaseClass) countdownDisplay.classList.add(phaseClass);

      if (secondsLeft <= 0 && !notStarted) {
        clearInterval(intervalId);
      }
    };

    const intervalId = setInterval(updateCountdown, 1000);
    updateCountdown();
  } else {
    console.log(`Countdown timer element with ID ${elementId} not found.`);
  }
}